// src/store/reducers/shiprocketReducer.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { base_url } from '../../utils/config'

// ─── Shiprocket Standard Delivery Thunks ───────────────
// 1. Fetch cheapest standard delivery quote
export const get_standard_quote = createAsyncThunk(
  'customer/get_standard_quote',
  async (
    { pickup_pincode, delivery_pincode, weight },
    { rejectWithValue }
  ) => {
    try {
      const { data } = await axios.get(
        `${base_url}/api/shiprocket/quote`,
        { params: { pickup_pincode, delivery_pincode, weight } }
      )
      // Resp: { courier_company_id, courier_name, quotedPrice, transit_time, estimated_delivery_days }
      return {
        courier_company_id:      data.courier_company_id,
        courier_name:            data.courier_name,
        quotedPrice:             data.quotedPrice,
        transit_time:            data.transit_time,
        estimated_delivery_days: data.estimated_delivery_days
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || 'Failed to fetch standard delivery quote'
      )
    }
  }
)

// 2. Request standard delivery booking
export const request_standard_delivery = createAsyncThunk(
  'customer/request_standard_delivery',
  async (
    { orderId, courier_company_id, courier_name, quotedPrice, transit_time, estimated_delivery_days },
    { rejectWithValue }
  ) => {
    try {
      const { data } = await axios.post(
        `${base_url}/api/shiprocket/request-standard-delivery`,
        { orderId, courier_company_id, courier_name, quotedPrice, transit_time, estimated_delivery_days }
      )
      // Expect: { request: StandardDeliveryRequest }
      return data.request
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || 'Failed to request standard delivery'
      )
    }
  }
)

const slice = createSlice({
  name: 'customer',
  initialState: {
    // Standard quote state
    standardQuote: {
      courier_company_id:      null,
      courier_name:            '',
      quotedPrice:             null,
      transit_time:            null,
      estimated_delivery_days: null
    },
    standardQuoteLoading:      false,
    standardQuoteError:        null,

    // Standard delivery request state
    standardRequest:                   null,
    requestStandardDeliveryLoading:   false,
    requestStandardDeliveryError:     null
  },
  reducers: {},
  extraReducers: builder =>
    builder
      // quote
      .addCase(get_standard_quote.pending, state => {
        state.standardQuoteLoading = true
        state.standardQuoteError   = null
      })
      .addCase(get_standard_quote.fulfilled, (state, { payload }) => {
        state.standardQuoteLoading = false
        state.standardQuote        = payload
      })
      .addCase(get_standard_quote.rejected, (state, { payload }) => {
        state.standardQuoteLoading = false
        state.standardQuoteError   = payload
      })

      // booking
      .addCase(request_standard_delivery.pending, state => {
        state.requestStandardDeliveryLoading = true
        state.requestStandardDeliveryError   = null
      })
      .addCase(request_standard_delivery.fulfilled, (state, { payload }) => {
        state.requestStandardDeliveryLoading = false
        state.standardRequest                = payload
      })
      .addCase(request_standard_delivery.rejected, (state, { payload }) => {
        state.requestStandardDeliveryLoading = false
        state.requestStandardDeliveryError   = payload
      }),
})

export default slice.reducer
